import { render } from "./PersonSelect.vue?vue&type=template&id=2e14a3e8&scoped=true&ts=true"
import script from "./PersonSelect.vue?vue&type=script&lang=ts"
export * from "./PersonSelect.vue?vue&type=script&lang=ts"

import "./PersonSelect.vue?vue&type=style&index=0&id=2e14a3e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e14a3e8"]])

export default __exports__